
import { updateDiagramDurationFormat, getDiagramDurationFormat } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type DurationFormatProps = ApiMethodBase & {
    days?: boolean;
    hours?: boolean;
    minutes?: boolean;
    seconds?: boolean;
}

export const changeDurationFormat = ({
    days,
    hours,
    minutes,
    seconds,
    eventEmitter,
}: DurationFormatProps) => {
    updateDiagramDurationFormat({days,hours,minutes,seconds});
    eventEmitter.emit(Event.updateDurationColumns);
};

export const getDurationFormat = (): DurationFormatProps => getDiagramDurationFormat();
